module.exports = __webpack_public_path__ + "images/icon-qr.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon-qr.png
// module id = cljQ
// module chunks = 1 2 3 4 5 6 7 8 9 10 11 12 13